import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";

const useCollections = () => {
  return useRestQuery(`${MONOLITH_ORIGIN}/api/v2/collection/`);
};

export default useCollections;
